import { render } from "./CargoIcon.vue?vue&type=template&id=10ab65f8"
import script from "./CargoIcon.vue?vue&type=script&lang=js"
export * from "./CargoIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__